import type { z } from 'zod';

import type { LegacyStudentTopicAnalyticsSchema } from './schemas';

type LegacyStudentTopicAnalyticsField = keyof z.infer<typeof LegacyStudentTopicAnalyticsSchema>;

export const DEFAULT_LEGACY_TOPIC_ANALYTICS_MARKS_TALLY = {
  attemptedMarks: 0,
  inaccuracyMarks: 0,
  missedMarks: 0,
  sillyMarks: 0,
};

const analyticsAttributes = [
  'analytics',
  'calculationAnalytics',
  'extendedResponseAnalytics',
  'graphingAnalytics',
  'multipleChoiceAnalytics',
  'proofAnalytics',
  'shortAnswerAnalytics',
] as const satisfies readonly LegacyStudentTopicAnalyticsField[];

const getAttributes = [
  'studentId',
  'subject',
  'topicCode',
  'topicExams',
  ...analyticsAttributes,
] as const satisfies readonly LegacyStudentTopicAnalyticsField[];

export const LegacyStudentTopicAnalyticsAttributes = {
  Get: getAttributes,
  Analytics: analyticsAttributes,
};
